// extracted by mini-css-extract-plugin
module.exports = {"separationArea":"Administration_separationArea__2pUdE"};